import React, { useState, useEffect, useCallback } from "react";
import { ReactComponent as CartIcon } from "../../../../icons/Cart.svg";
import axios from "axios";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import { CartModal } from "../Modal/CartModal";
import { MenuStyled } from "./Menu.styled";

export const CartMenu = () => {
    const [isCartOpen, setIsCartOpen] = useState(false);
    const [items, setItems]           = useState([]);
    const [loading, setLoading]       = useState(false);
    const apiBaseUrl                  = `${process.env.REACT_APP_API_BASE_URL}/user/cart`;

    const fetchCartItems = useCallback(async () => {
        setLoading(true);
        try {
            const token = sessionStorage.getItem("accessToken");
            if (!token) return;
            const { data } = await axios.get(`${apiBaseUrl}/by-session/get`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setItems(
                Array.isArray(data)
                    ? data.map(i => ({ ...i, quantity: i.totalQuantity ?? i.quantity ?? 1 }))
                    : []
            );
        } catch (err) {
            console.error(err);
            //Notify.failure("Не удалось загрузить корзину");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCartItems();
    }, [fetchCartItems]);

    useEffect(() => {
        const handler = () => fetchCartItems();
        window.addEventListener("cartUpdated", handler);
        return () => window.removeEventListener("cartUpdated", handler);
    }, [fetchCartItems]);

    const handleOutsideClick = useCallback(e => {
        if (!e.target.closest('[name="cart"]')) {
            setIsCartOpen(false);
        }
    }, []);
    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, [handleOutsideClick]);

    const totalItemsCount = items.length;

    return (
        <MenuStyled $quantity={totalItemsCount}>
            <button
                name="cart"
                aria-label="Open Cart Modal"
                onClick={() => {
                    setIsCartOpen(o => !o);
                    if (!isCartOpen) fetchCartItems();
                }}
            >
                <CartIcon />
            </button>
            {isCartOpen && (
                <CartModal
                    onClick={() => setIsCartOpen(false)}
                    items={items}
                    loading={loading}
                    refresh={fetchCartItems}
                />
            )}
        </MenuStyled>
    );
};
